"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
//
// assets
//
const noApiKeys_webp_1 = __importDefault(require("../../../assets/images/dashboard/noApiKeys.webp"));
const appsCopy_1 = require("../../../copy/appsCopy");
const queryDefinitions_1 = require("../../../queryDefinitions");
const tokenHeader_1 = require("../../../tokenHeader");
const withAccount_1 = require("../../withAccount");
const Toast_1 = __importDefault(require("../../general/Toast/Toast"));
const useToast_1 = __importDefault(require("../../general/Toast/useToast"));
const useAccountChange_1 = __importDefault(require("../../useAccountChange"));
//
// components
//
const AppModule_1 = __importDefault(require("./AppModule"));
//
// styles
//
const StyledHeader_1 = require("../StyledHeader");
const StyledMainContainer_1 = require("../StyledMainContainer");
const StyledMessageContainer_1 = require("../StyledMessageContainer");
const LoadingSpinner_1 = __importDefault(require("../../general/LoadingSpinner"));
const StyledErrorText_1 = require("../StyledErrorText");
const StyledGraphic_1 = require("../StyledGraphic");
const StyledMediumText_1 = require("../StyledMediumText");
const StyledGreyText_1 = require("../StyledGreyText");
const Apps = ({ accountId }) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((options?... Remove this comment to see the full error message
    const [getAppListings, { data, error }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_APP_LISTINGS);
    const [uninstallAppMutation, { data: uninstallData }] = (0, client_1.useMutation)(queryDefinitions_1.UNINSTALL_APP);
    const { toastParams, setToastMessage } = (0, useToast_1.default)();
    const uninstallApp = (clientId) => {
        // we have to read `clientId` from the getAppListings call
        // but send it back as `appClientId`
        uninstallAppMutation({
            variables: {
                input: {
                    accountId: accountId,
                    appClientId: clientId
                }
            }
        });
    };
    (0, useAccountChange_1.default)(() => {
        // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
        getAppListings();
    });
    (0, react_1.useEffect)(() => {
        if (uninstallData) {
            setToastMessage('Uninstalled');
            // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
            getAppListings();
        }
    }, [uninstallData]);
    function listApps() {
        const appArray = [];
        data.appListings.map((app) => {
            appArray.push(react_1.default.createElement(AppModule_1.default, { app: app, key: app.name, uninstall: uninstallApp }));
        });
        return react_1.default.createElement("div", null, appArray);
    }
    function renderLoading() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(LoadingSpinner_1.default, null),
            react_1.default.createElement(StyledMediumText_1.StyledMediumText, { className: 'loading', role: 'paragraph' }, appsCopy_1.appsCopy.loading)));
    }
    function displayError() {
        if (error.message.includes('ECONNREFUSED') ||
            error.message.toLowerCase().includes('failed')) {
            return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, appsCopy_1.appsCopy.fetchError));
        }
        return (react_1.default.createElement(StyledErrorText_1.StyledErrorText, { className: 'error', role: 'alert' }, error.message));
    }
    // should never happen during normal use
    function renderNoRecords() {
        return (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
            react_1.default.createElement(StyledGraphic_1.StyledGraphic, { alt: 'robotic arm holding a key up to a computer screen', src: noApiKeys_webp_1.default }),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header no-records', role: 'heading' }, appsCopy_1.appsCopy.noAppsHeader),
            react_1.default.createElement(StyledGreyText_1.StyledGreyText, { className: 'no-records-paragraph', role: 'paragraph' }, appsCopy_1.appsCopy.noAppsParagraph)));
    }
    function renderApps() {
        return (react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, { className: 'apps' },
            react_1.default.createElement(Toast_1.default, Object.assign({}, toastParams)),
            react_1.default.createElement(StyledHeader_1.StyledHeader, { "aria-level": 1, className: 'header', role: 'heading' }, appsCopy_1.appsCopy.mainHeader),
            listApps()));
    }
    if (error) {
        return displayError();
    }
    if (data && data.appListings.length === 0) {
        return renderNoRecords();
    }
    if (data) {
        return renderApps();
    }
    return renderLoading();
};
exports.default = (0, withAccount_1.withAccount)(Apps);
